const footerColumns = [
  {
    title: "内容导航",
    links: [
      { label: "热播推荐", href: "#hot" },
      { label: "新剧上线", href: "#new" },
      { label: "分类浏览", href: "#category" },
      { label: "追剧日历", href: "#schedule" },
    ],
  },
  {
    title: "使用帮助",
    links: [
      { label: "追剧指南", href: "#guide" },
      { label: "高清观影", href: "#quality" },
      { label: "平台亮点", href: "#features" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "热门题材",
    links: [
      { label: "古装权谋", href: "#category" },
      { label: "悬疑推理", href: "#category" },
      { label: "都市情感", href: "#category" },
      { label: "科幻冒险", href: "#category" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                大师兄影视
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-100/70">
              集中整理在线观看、免费追剧、高清观影与全集观看的使用思路，并以热播推荐与更新日历帮助缩小查询范围，
              让每一部想看的剧都能更快找到。
            </p>
            <div className="mt-5 flex flex-wrap gap-3 text-xs text-background-100/60">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-refresh-line"></i>
                每日更新
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-hd-line"></i>
                高清资源
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-device-line"></i>
                多端观看
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">
                {column.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 大师兄影视 · 本页内容为影视资讯整理，具体排期以官方播出为准。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            页面信息仅供影视浏览与追剧参考
          </p>
        </div>
      </div>
    </footer>
  );
}